<template>
  <div class="wv_frame fx fdc">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.wv_frame {
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;
  background-color: #ffffff;

  .wv_page {
    padding: $main_P;
  }
  .wv_button {
    padding: 0 $main_P;
    padding-bottom: 1rem;
  }
}
</style>